import { Button } from '@ixyberfree/ixybercomponents';
import React from 'react';
import './PropertyEditWindow.css';
// import { Input } from 'reactstrap';
interface IPropsPropertyEditWindow {
    inpObj: any;
    id: string;
    propsName: string;
    typeValue: string;
    closeCB?: Function;
    saveCB?: Function;
}

export const PropertyEditWindow: React.FC<IPropsPropertyEditWindow> = ({
    inpObj,
    id,
    propsName,
    typeValue,
    closeCB,
    saveCB
}) => {
    let [editObj, setEditObj] = React.useState<string>(typeof inpObj == 'string' ? '[]' : JSON.stringify(inpObj));

    let [CountArr, setCountArr] = React.useState<number[]>([]);

    let [selectIndex, setSelectItem] = React.useState<number[]>([-1, -1]);

    let [selectCells, setSelectCells] = React.useState<number[][]>([]);

    let [isButtonPressed, setisButtonPressed] = React.useState<boolean>(false);

    const clickOut = React.useCallback(() => {
        setisButtonPressed(false);
    }, [isButtonPressed]);

    React.useEffect(() => {
        let inpObjLoc = JSON.parse(editObj);
        let CountArrTemp: number[] = [];
        if (inpObjLoc == null) {
            CountArrTemp[0] = 1;
            CountArrTemp[1] = 0;
            setEditObj('[]');
        } else {
            CountArrTemp[0] = inpObjLoc.length;
            CountArrTemp[1] = 0;

            for (let i = 0; i < inpObjLoc.length; i++) {
                let item = inpObjLoc[i];
                if (Array.isArray(item)) CountArrTemp[1] = Math.max(CountArrTemp[1], item.length);
                else {
                    CountArrTemp[1] = 0;
                    break;
                }
            }
        }

        setCountArr(CountArrTemp);

        window.addEventListener('mouseup', clickOut);

        return () => {
            window.removeEventListener('mouseup', clickOut);
        };
    }, [editObj]);

    const outofrange = (i: number, j: number) => {
        return (
            Math.max(selectCells[0]?.[0], selectCells[1]?.[0]) >= i &&
            Math.min(selectCells[0]?.[0], selectCells[1]?.[0]) <= i &&
            Math.max(selectCells[0]?.[1], selectCells[1]?.[1]) >= j &&
            Math.min(selectCells[0]?.[1], selectCells[1]?.[1]) <= j
        );
    };

    const genCell = (item: any, i: number, j: number) => {
        return (
            <td
                key={`${i}-${j}`}
                className={outofrange(i, j) ? 'select' : ''}
                onMouseDown={(e) => {
                    setSelectCells([
                        [i, j],
                        [i, j]
                    ]);
                    setisButtonPressed(true);
                }}
                onMouseMove={(e) => {
                    if (isButtonPressed) {
                        setSelectCells([...[selectCells[0], [i, j]]]);
                    }
                }}>
                {i != selectIndex[0] || j != selectIndex[1] ? (
                    <span
                        onClick={(e) => {
                            setSelectItem([-1, -1]);
                        }}
                        onDoubleClick={(e) => {
                            setSelectItem([i, j]);
                        }}>
                        {item}
                    </span>
                ) : (
                    <input
                        onKeyUp={(e) => {
                            if (e.key === 'Enter' || e.keyCode === 13) {
                                setSelectItem([-1, -1]);
                            }
                        }}
                        onChange={(e) => {
                            let inpObjLoc = JSON.parse(editObj);
                            const value = isTypeNumber() ? Number(e.currentTarget.value) : e.currentTarget.value;
                            //проверка на размерность массива
                            const isOneDimensional = Array.isArray(inpObjLoc) && !inpObjLoc.some(Array.isArray);

                            if (isOneDimensional) {
                                inpObjLoc[i] = value;
                            } else {
                                if (j != -1) {
                                    inpObjLoc[i][j] = value;
                                }
                            }
                            setEditObj(JSON.stringify(inpObjLoc));
                        }}
                        defaultValue={item}
                        autoFocus
                    />
                )}
            </td>
        );
    };

    const isTypeNumber = () => {
        let typesNumber = [
            'byte',
            'sbyte',
            'bool',
            'decimal',
            'double',
            'float',
            'int',
            'uint',
            'nint',
            'long',
            'short',
            'ushort',
            'enum'
        ];
        return typesNumber.indexOf(typeValue.replaceAll('[]', '')) != -1 ? true : false;
    };

    const genPage = () => {
        let res = <div></div>;

        if (typeValue.split('[]').length - 1 != 2 && typeValue.split('[]').length - 1 != 1) {
            res = (
                <div>
                    Value:{' '}
                    <input
                        style={{ margin: '5px' }}
                        defaultValue={editObj}
                        onChange={(e) => {
                            let val = JSON.stringify(isTypeNumber() ? Number(e.target.value) : e.target.value);
                            setEditObj(val);
                        }}
                    />
                </div>
            );
        } else {
            let inpObjLoc = JSON.parse(editObj);
            let trArr = [];

            for (let i = 0; i < CountArr[0]; i++) {
                let item = inpObjLoc[i];

                if (CountArr[1] == 0) {
                    trArr.push(<tr key={i}>{genCell(item, i, 0)}</tr>);
                } else {
                    const col = [];
                    for (let j = 0; j < CountArr[1]; j++) {
                        if (item) {
                            col.push(genCell(item[j], i, j));
                        }
                    }

                    trArr.push(
                        <tr key={i}>
                            {col.map(function (trItem: any) {
                                return trItem;
                            })}
                        </tr>
                    );
                }
            }

            res = (
                <div>
                    <input
                        style={{ width: '45px' }}
                        defaultValue={CountArr[0]}
                        onChange={(e) => {
                            let inpObjLoc = JSON.parse(editObj);
                            let newinpObjLoc: any[] = [];
                            for (let i = 0; i < Number(e.currentTarget.value); i++) {
                                if (inpObjLoc.length > i) {
                                    newinpObjLoc.push(inpObjLoc[i]);
                                } else {
                                    let item = null;
                                    if (CountArr[1] > 0) {
                                        item = [];
                                        for (let j = 0; j < CountArr[1]; j++) {
                                            item.push(null);
                                        }
                                    }
                                    newinpObjLoc.push(item);
                                }
                            }
                            setCountArr([Number(e.currentTarget.value), CountArr[1]]);
                            setEditObj(JSON.stringify(newinpObjLoc));
                        }}
                        type="number"
                    />{' '}
                    -{' '}
                    <input
                        style={{ width: '45px' }}
                        defaultValue={CountArr[1]}
                        onChange={(e) => {
                            let inpObjLoc = JSON.parse(editObj);
                            let newinpObjLoc: any[] = [];

                            for (let i = 0; i < inpObjLoc.length; i++) {
                                let item = inpObjLoc[i];
                                if (Number(e.currentTarget.value) == 0) {
                                    if (Array.isArray(item)) newinpObjLoc.push(item[0]);
                                    else newinpObjLoc.push(item);
                                } else {
                                    let arrcells: any[] = [];
                                    if (Array.isArray(item)) {
                                        for (let j = 0; j < Math.min(item.length, Number(e.currentTarget.value)); j++) {
                                            arrcells.push(item[j]);
                                        }
                                    } else {
                                        arrcells.push(item);
                                    }

                                    for (let j = arrcells.length; j < Number(e.currentTarget.value); j++) {
                                        arrcells.push(null);
                                    }

                                    newinpObjLoc.push(arrcells);
                                }
                            }

                            setCountArr([CountArr[0], Number(e.currentTarget.value)]);
                            setEditObj(JSON.stringify(newinpObjLoc));
                        }}
                        type="number"
                    />
                    <table
                        className="tgExcel"
                        onPaste={(e) => {
                            if (selectIndex[0] == -1 && selectIndex[1] == -1) {
                                e.preventDefault();
                                let data = e.clipboardData.getData('text/plain');
                                setEditObj(
                                    JSON.stringify(
                                        data
                                            .split(/\r\n|\n|\r/g)
                                            .filter((i) => i)
                                            .map((row) =>
                                                row.split('\t').map((cell) => (isTypeNumber() ? Number(cell) : cell))
                                            )
                                    )
                                );
                                setSelectItem([-1, -1]);
                            }
                        }}
                        onCopy={(e) => {
                            e.preventDefault();
                            let inpObjLoc = JSON.parse(editObj);
                            let copyData: any[] = [];

                            for (let i = 0; i < inpObjLoc.length; i++) {
                                let item = inpObjLoc[i];
                                if (!Array.isArray(item)) {
                                    if (outofrange(i, 0)) {
                                        copyData.push(item);
                                    }
                                } else {
                                    let tempitem: any[] = [];
                                    for (let j = 0; j < item.length; j++) {
                                        if (outofrange(i, j)) {
                                            tempitem.push(item[j]);
                                        }
                                    }
                                    if (tempitem.length != 0) copyData.push(tempitem);
                                }
                            }

                            e.clipboardData.setData(
                                'text',
                                copyData.map((elem: any) => (Array.isArray(elem) ? elem.join('\t') : elem)).join('\n')
                            );
                        }}>
                        <tbody>
                            {trArr.map(function (trItem: any) {
                                return trItem;
                            })}
                        </tbody>
                    </table>
                </div>
            );
        }

        return res;
    };

    return (
        <div
            style={{
                width: '100%',
                height: '100%',
                top: 0,
                left: 0,
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center'
            }} /*onClick={() => closeCB && closeCB()}*/
        >
            <div
                style={{
                    background: 'white',
                    padding: '1em',
                    display: 'flex',
                    justifyContent: 'space-between',
                    flexDirection: 'column'
                }}
                onClick={(e) => e.stopPropagation()}>
                <div style={{ display: 'flex', width: '760px', height: '500px', overflow: 'auto' }}>{genPage()}</div>
                <div style={{ display: 'flex', justifyContent: 'center', padding: '5px' }}>
                    <Button
                        text="Сохранить"
                        size="small"
                        styleType="filled"
                        onClick={() =>
                            saveCB &&
                            saveCB(
                                id,
                                propsName,
                                !isNaN(parseFloat(editObj)) && editObj != '' ? Number(editObj) : `${editObj}`
                            )
                        }
                    />
                    <div style={{ width: '1em' }}></div>
                    <Button text="Отмена" size="small" styleType="tinted" onClick={() => closeCB && closeCB()} />
                </div>
            </div>
        </div>
    );
};
